module.exports = __webpack_public_path__ + "static/img/shadow-cellphone.f30064a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/shadow-cellphone.jpg
// module id = R4o3
// module chunks = 1